if($('header#header').length){
    $('.navigation-buttons').prepend('<a href="'+pravidelneUrl+'" class="btn btn-primary pravidelne">Chci pomáhat pravidelně</a><a href="'+jednorazoveUrl+'" class="btn btn-primary jednorazove">Zatím pomůžu jednorázově</a>')
}